import React, { useEffect, useState } from 'react'
import * as pdfjsLib from 'pdfjs-dist/webpack'
import { Seccion, Label, Boton, Input } from "asocomponents"
import PDFViewer1 from '../PDFViewer/PDFViewer'
import { numeroEnPalabras, obtenerApoderado } from '../../../helpers/funciones'

const CargarActaAcuerdoPdf = () => {
  const [file, setFile] = useState(null)
  const [pdfText, setPdfText] = useState(null)

  const [porcentaje, setPorcentaje] = useState(10)
  const [correo, setCorreo] = useState('')
  const [correoAso, setCorreoAso] = useState('')
  const [apoderado, setApoderado] = useState('')
  const [direccion, setDireccion] = useState('')

  const [monto, setMonto] = useState('')
  const [montoOriginal, setMontoOriginal] = useState(0)
  const [montoOriginalString, setMontoOriginalString] = useState(0)
  const [letrado, setLetrado] = useState('')
  const [matricula, setMatricula] = useState('')
  const [expediente, setExpediente] = useState('')
  const [comision, setComision] = useState('')
  const [trabajador, setTrabajador] = useState('')
  const [montoLetras, seMontoLetras] = useState('')

  const [generado, setGenerado] = useState(false)

  const extraerTextoPDF = async (pdfData) => {
    const pdfDoc = await pdfjsLib.getDocument({ data: pdfData }).promise
    let fullText = ''

    for (let i = 1; i <= pdfDoc.numPages; i++) {
      const page = await pdfDoc.getPage(i)
      const textContent = await page.getTextContent()
      const textItems = textContent.items.map(item => item.str).join(' ')
      fullText += textItems + ' '
    }

    obtenerValores(fullText.replace(/\s+/g, ' '))
    setPdfText(fullText.replace(/\s+/g, ' '))
  }

  const extraerTextoDesdeHastaTermino = (text, termInicio, termFin, termExtra) => {
    let extracted = ''
    const index = text.indexOf(termInicio)
    if (index !== -1) {
      let startIndex = index + termInicio.length
      let endIndex = text.slice(startIndex).indexOf(termFin)

      if (endIndex !== -1) {
        extracted = text.substring(startIndex, startIndex + endIndex)
      }
      else {
        endIndex = text.slice(startIndex).indexOf(termExtra)
        extracted = text.substring(startIndex, startIndex + endIndex)
      }

      return extracted
    } else {
      return 'No encontrado'
    }
  }

  const extraerTextoHaciaAtras = (text, termInicio, termFin) => {
    const inicioIndex = text.lastIndexOf(termInicio)
    if (inicioIndex === -1) {
      return ""
    }

    const finIndex = text.lastIndexOf(termFin, inicioIndex)
    if (finIndex === -1) {
      return "No encontrado"
    }

    return text.substring(finIndex + 1, inicioIndex + termInicio.length)
  }

  const obtenerValores = (texto) => {
    //Recupero el correo
    recuperarCorreo(texto)

    //Recupero el cuil del apoderado
    recuperarApoderado(texto)

    //Recupero la correo de Asociart
    //recuperarCorreoAsociart(texto)

    //Recupero el monto
    recuperarMonto(texto)

    //Recupero el Letrado
    recuperarLetrado(texto)

    //Recupero la matricula
    recuperarMatricula(texto)

    //Recupero el expediente
    recuperarExpediente(texto)

    //Recupero la comision medica
    recuperarComision(texto)

    //Recupero el trabajador
    recuperarTrabajador(texto)

    //Recupero la direccion letrado
    recuperarDireccion(texto)
  }

  const recuperarDireccion = (texto) => {
    let dom = "No encontrado"
    let palabraBuscada = texto.indexOf('letrado')

    let palabra = texto.substring(palabraBuscada, palabraBuscada + 400)

    if (palabraBuscada !== -1) {
      if (dom === "No encontrado")
        dom = extraerTextoDesdeHastaTermino(palabra, 'en la calle', 'y electrónico')
    }

    setDireccion(dom.substring(0, dom.length - 2).trim()) //Le quito la coma del final
  }

  const recuperarComision = (texto) => {
    setComision(extraerTextoDesdeHastaTermino(texto, 'CM N°', ' DI'))
  }

  const recuperarMonto = (texto) => {
    const monto = parseFloat(extraerTextoDesdeHastaTermino(texto, '$', ')').replace(/\s/g, '').replace(/\./g, '').replace(',', '.'))
    const diez_por_ciento = monto * 0.10
    setMontoOriginal(monto)
    setMontoOriginalString(monto.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
    setMonto(diez_por_ciento.toFixed(2))
  }

  const recuperarMatricula = (texto) => {
    let mat = "No encontrado"

    mat = extraerTextoDesdeHastaTermino(texto, 'MATRICULA', ',')

    if (mat === "No encontrado")
      mat = extraerTextoDesdeHastaTermino(texto, 'MATRÍCULA', ',')

    setMatricula(mat)
  }

  const recuperarExpediente = (texto) => {
    let exp = "No encontrado"
    let palabraBuscada = texto.indexOf('EXPEDIENTE')

    const palabra = texto.substring(palabraBuscada, palabraBuscada + 50)

    if (palabraBuscada !== -1) {
      if (exp === "No encontrado")
        exp = extraerTextoDesdeHastaTermino(palabra, 'S.R.T. N°', 'C')
      if (exp === "No encontrado")
        exp = extraerTextoDesdeHastaTermino(palabra, 'NRO.: ', ' ')
    }

    setExpediente(exp.trim())
  }

  const recuperarCorreo = (texto) => {
    let cor = extraerTextoDesdeHastaTermino(texto, 'correo electrónico', ')')

    if (cor === "No encontrado")
      cor = extraerTextoDesdeHastaTermino(texto, 'correo  electrónico', ')')
    if (cor === "No encontrado")
      cor = extraerTextoDesdeHastaTermino(texto, 'correo   electrónico', ')')

    setCorreo(cor.trim())
  }

  const recuperarCorreoAsociart = (cuil) => {
    //setCorreoAso(extraerTextoHaciaAtras(texto, '@asociart.com.ar', ' '))
    const apod = obtenerApoderado(cuil)
    setCorreoAso(apod ? apod.mail : '')
  }

  const recuperarTrabajador = (texto) => {
    let trab = "No encontrado"
    let palabraBuscada = texto.indexOf('por un la')

    const palabra = texto.substring(palabraBuscada, palabraBuscada + 100)

    if (palabraBuscada !== -1) {
      if (trab === "No encontrado")
        trab = extraerTextoDesdeHastaTermino(palabra, 'Sr.', ',')
      if (trab === "No encontrado")
        trab = extraerTextoDesdeHastaTermino(palabra, 'Sr/a.', ',')
      if (trab === "No encontrado")
        trab = extraerTextoDesdeHastaTermino(palabra, 'Sra.', ',')
      if (trab === "No encontrado")
        trab = extraerTextoDesdeHastaTermino(palabra, 'Sra .', ',')
      if (trab === "No encontrado")
        trab = extraerTextoDesdeHastaTermino(palabra, 'Sr .', ',')
    }
    setTrabajador(trab.trim())
  }

  const recuperarApoderado = (texto) => {
    let apod = "No encontrado"
    let palabraBuscada = texto.indexOf('apoderad')

    let palabra = texto.substring(palabraBuscada, palabraBuscada + 300)

    if (palabraBuscada !== -1) {
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'C.U.I.L N°', ',', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'C.U.I.L. N°', ')', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'CUIL N°', ')', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'CUIL', ')', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'C.U.I.T N°', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'C.U.I.T. Nº', ')', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'C.U.I.T. N°', ')', ',')
      if (apod === "No encontrado")
        apod = extraerTextoDesdeHastaTermino(palabra, 'CUIT N°', ')', ',')
    }

    setApoderado(apod.replace(/\s/g, '').replace("-", "").replace("-", "").trim())

  }

  const recuperarLetrado = (texto) => {
    let patro = "No encontrado"
    let palabraBuscada = texto.indexOf('patrocinio')

    if (palabraBuscada !== -1) {

      patro = extraerTextoDesdeHastaTermino(texto.substring(palabraBuscada), 'Dr./a', ', (')

      if (patro === "No encontrado")
        patro = extraerTextoDesdeHastaTermino(texto.substring(palabraBuscada), 'Dr.', ', (')

      if (patro === "No encontrado")
        patro = extraerTextoDesdeHastaTermino(texto.substring(palabraBuscada), ' Dra.', ', (')
    }
    setLetrado(patro.trim())
  }

  const handleFileChange = (event) => {
    setFile(event.target.files[0])
  }

  const handleProcesarPDF = async () => {
    if (file) {
      const reader = new FileReader()
      reader.onload = async (e) => {
        const pdfData = new Uint8Array(e.target.result)
        await extraerTextoPDF(pdfData)
      }
      reader.readAsArrayBuffer(file)
    }
    setPorcentaje(10)
  }

  const handleCorreo = (valor) => {
    setCorreo(valor)
  }

  const handleMonto = (valor) => {
    setMonto(valor)
  }

  const handleLetrado = (valor) => {
    setLetrado(valor)
  }

  const handlePorcentaje = (valor) => {
    setPorcentaje(valor)
    setMonto(parseFloat(+montoOriginal * valor / 100).toFixed(2))
  }

  const handleMatricula = (valor) => {
    setMatricula(valor)
  }

  const handleExpediente = (valor) => {
    setExpediente(valor)
  }

  const handleApoderado = (valor) => {
    setApoderado(valor)
  }

  const handleComision = (valor) => {
    setComision(valor)
  }

  const handleTrabajador = (valor) => {
    setTrabajador(valor)
  }

  const handleCorreoAso = (valor) => {
    setCorreoAso(valor)
  }

  const handleDireccion = (valor) => {
    setDireccion(valor)
  }

  const handleMontoLetras = (valor) => {
    seMontoLetras(valor)
  }

  const generatePdf = async () => {
    setGenerado(true)
  }

  useEffect(() => {
    recuperarCorreoAsociart(apoderado)
  }, [apoderado])

  useEffect(() => {
    seMontoLetras(numeroEnPalabras(monto))
  }, [monto])


  return (
    <>
      <Seccion titulo="Paso 1: Seleccionar archivo PDF" />
      <div className="flex flex-col justify-center items-center space-y-4 mt-6">
        <input type="file" accept="application/pdf" onChange={handleFileChange} />
        <Boton onClick={handleProcesarPDF} texto="Procesar PDF" fondo="rojo" />
      </div>
      <div className="w-full border-t border-gray-300 my-4"></div>
      <Seccion titulo="Paso 2: Generar el Acuerdo de Honorarios Profesionales" />
      <div className="flex flex-row justify-center items-center">
        <Label texto="Monto Acta:" />
        <Label texto={montoOriginalString} />
        <Label texto="Monto calculado:" />
        <Input type="text" valor={monto} onChange={handleMonto} width='w-30' />
        <Label texto="Porcentaje:" />
        <Input type="text" valor={porcentaje} onChange={handlePorcentaje} width='w-30' />
        <Input type="text" valor={montoLetras} onChange={handleMontoLetras} width='w-80' />
      </div>
      <div className="flex flex-row justify-center items-center mt-4">
        <Label texto="Correo Letrado:" />
        <Input type="text" valor={correo} onChange={handleCorreo} width='w-52' />
        <Label texto="Letrado:" />
        <Input type="text" valor={letrado} onChange={handleLetrado} width='w-64' />
        <Label texto="Matricula:" />
        <Input type="text" valor={matricula} onChange={handleMatricula} width='w-30' />
        <Label texto="Dirección:" />
        <Input type="text" valor={direccion} onChange={handleDireccion} width='w-30' />
      </div>
      <div className="flex flex-row justify-center items-center mt-4">
        <Label texto="Trabajador:" />
        <Input type="text" valor={trabajador} onChange={handleTrabajador} width='w-30' />
        <Label texto="Expediente:" />
        <Input type="text" valor={expediente} onChange={handleExpediente} width='w-30' />
        <Label texto="Comisión:" />
        <Input type="text" valor={comision} onChange={handleComision} width='w-30' />
      </div>
      <div className="flex flex-row justify-center items-center mt-4">
        <Label texto="Correo Apoderado:" />
        <Input type="text" valor={correoAso} onChange={handleCorreoAso} width='w-40' />
        <Label texto="Apoderado:" />
        <Input type="text" valor={apoderado} onChange={handleApoderado} width='w-30' />
      </div>
      <div className="flex flex-row justify-center items-start mt-6">
        <Boton onClick={generatePdf} texto="Generar Acuerdo PDF" fondo="rojo" />
      </div>
      <div className="w-full border-t border-gray-300 my-4"></div>
      <Seccion titulo="Paso 3: Archivo PDF Generado" />
      <div className="flex flex-col justify-center items-center mt-6 w-[100%]">
        {generado && (
          <>
            <PDFViewer1 correo={correo} monto={monto} matricula={matricula} letrado={letrado} expediente={expediente} comision={comision} trabajador={trabajador} apoderado={apoderado} correoCC={correoAso} direccion={direccion} montoLetras={montoLetras} />
          </>
        )}
      </div>
    </>
  )
}

export default CargarActaAcuerdoPdf